import { useQuery } from "@tanstack/react-query";
import { StoreScratcherReconciliationAuditsRangeModel } from "models";
import { getStoreScratcherReconciliationAuditsByRange } from "services/auditService";

export function useAuditDashboardStoreScratcherReconciliationAuditsRange(
  storeId: string | null | undefined,
  startDate: string | null | undefined,
  endDate: string | null | undefined,
  enabled = true
) {
  return useQuery<StoreScratcherReconciliationAuditsRangeModel, Error>({
    queryKey: ["audit-dashboard-scratcher-reconciliation-audits-range", storeId, startDate, endDate],
    queryFn: async () => {
      const audits = await getStoreScratcherReconciliationAuditsByRange(storeId!, startDate!, endDate!);
      return StoreScratcherReconciliationAuditsRangeModel.fromAuditRows(audits);
    },
    enabled: Boolean(enabled && storeId && startDate && endDate),
  });
}
